import { PatientSimple, PatientSimpleQuery } from '@dreryk/egabinet-patient-frontend-api';

import { performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { FormContextValues } from '@dreryk/react-common';
import { Autosuggest } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { getPatientDisplayedFullName } from '../../../common/common.utils';
import { patientTranslationKeys } from '../../../translations';

import { ExistingPatientFormPatientSearchItem } from './ExistingPatientFormPatientSearchItem';

const labelExtractor = (patient: PatientSimple): string =>
   getPatientDisplayedFullName(patient.firstName, patient.lastName) ?? '';
const itemRenderer = (patient: PatientSimple): JSX.Element => {
   return <ExistingPatientFormPatientSearchItem patient={patient} />;
};
const createExistingPatientSearchCreator = (comparedPatientId: number) => {
   return (searchText: string | null) => {
      return async (): Promise<PatientSimple[]> => {
         return performCqrsQuerySearch<PatientSimple>(() => {
            const query = new PatientSimpleQuery();
            query.freeformCriteria = Slot.emptyIfNull(searchText);
            query.excludedId = Slot.emptyIfNull(comparedPatientId ?? null);
            return query;
         });
      };
   };
};

const EXISTING_PATIENT_FIELD_NAME = 'existingPatient';
type ExistingPatientFormBeanPart = {
   [EXISTING_PATIENT_FIELD_NAME]: PatientSimple | null;
};
type ExistingPatientAutosuggestProps = {
   readonly register: FormContextValues<ExistingPatientFormBeanPart>['register'];
   readonly comparedPatientId: number;
};

export const ExistingPatientAutosuggest = (props: ExistingPatientAutosuggestProps): JSX.Element => {
   return (
      <Autosuggest<PatientSimple>
         testId={'existingPatient'}
         itemRenderer={itemRenderer}
         searchCreator={createExistingPatientSearchCreator(props.comparedPatientId)}
         labelExtractor={labelExtractor}
         keyProperty={'id'}
         controller={props.register(EXISTING_PATIENT_FIELD_NAME, { required: true })}
         placeholder={patientTranslationKeys.unconfirmed.fillPatientDataForSearch}
         label={patientTranslationKeys.unconfirmed.existingPatientFile}
      />
   );
};
